import React from 'react';
import { useField, useFormikContext } from 'formik';
import DatePicker from 'react-datepicker';
import './DatePickerField.scss';

const DatePickerField = ({ ...props }) => {
  const { setFieldValue } = useFormikContext();
  const [field] = useField(props);
  return (
    <DatePicker
      {...field} // eslint-disable-line
      {...props} // eslint-disable-line
      dateFormat="dd/MM/yyyy"
      selected={(field.value && new Date(field.value)) || null}
      onChange={(val) => {
        setFieldValue(field.name, val);
      }}
      withPortal
    />
  );
};

export default DatePickerField;
